import React from 'react';
import CountUp from 'react-countup';

const Price = React.memo(({ value, negative = false, count = false }) => {
  if (value == null) return null;

  const numeric = Math.abs(Number(value));
  const sign = negative ? '-' : '';

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      {count ? (
        <CountUp
          end={numeric}
          decimals={2}
          duration={1.5}
          separator=" "
          prefix={`${sign}`}
          suffix=" zł"
        />
      ) : (
        `${sign}${numeric.toFixed(2)} zł`
      )}
    </span>
  );
});

export default Price;
